import {
  ParsedCustomDimensions,
  RouteOptions,
  SetCustomDimensionsArgs,
  ThirdPartyTrackingAgent,
  ThirdPartyTrackingAgentArgs,
} from './types';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { checkThirdPartyTrackingStorageInit } from '../../configParametersRepository/storageClient/storage';
import { trackEvent } from './events';
import { trackGA4Promo } from './promotions';
import { trackQualtrics } from './surveys';

const getPathName = () => {
  const url = new URL(window.location.href);
  return url.hash.replace(/^#/, '');
};

const parseSetCustomDimensionArgs = (
  args: SetCustomDimensionsArgs | [ParsedCustomDimensions]
): ParsedCustomDimensions => {
  if (typeof args[0] === 'number' || typeof args[0] === 'string') {
    return {
      dimension: args[0],
      value: args[1],
    };
  }
  return args[0];
};

export const routeOptions: RouteOptions = {
  pageMap: {},
  matcher: {
    getPathParams: () => ({}),
    findMatchingPattern: () => undefined,
  },
};

export const getTrackingPageFromUrl = ({ pageMap, matcher }: RouteOptions) => {
  const routePattern = matcher.findMatchingPattern(getPathName());
  return routePattern ? pageMap[routePattern] : undefined;
};

export const createThirdPartyTrackingAgent = ({
  trackSurvey,
  trackFireEvent,
  trackPage,
  routePageMap,
  routeMatcher,
}: ThirdPartyTrackingAgentArgs): ThirdPartyTrackingAgent => {
  routeOptions.matcher = routeMatcher;
  routeOptions.pageMap = routePageMap;

  const setCustomDimension = async (...args: SetCustomDimensionsArgs) => {
    checkThirdPartyTrackingStorageInit();
    if (typeof window === 'undefined') return;
    const { getTrackingStorageClient } = createConfigParametersRepository();
    const storageClient = getTrackingStorageClient();
    const { dimension, value } = parseSetCustomDimensionArgs(args);
    storageClient?.updateCustomParamsAndDimensions({
      [`dimension${dimension}`]: value,
    });
  };

  return {
    trackQualtrics,
    trackSurvey,
    trackFireEvent,
    trackPage: trackPage,
    setCustomDimension,
    trackEvent,
    trackPromotion: trackGA4Promo,
  };
};
